var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElipse2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 229,
    viewBox: "0 0 115 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 229C84.1327 229 55.0092 216.937 33.5363 195.464C12.0633 173.991 -6.33235e-06 144.867 -5.00495e-06 114.5C-3.67756e-06 84.1327 12.0634 55.0092 33.5363 33.5363C55.0092 12.0634 84.1327 -1.74702e-06 114.5 -5.00495e-06L114.5 114.5L114.5 229Z",
    fill: "#FF9595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipse2);
export default __webpack_public_path__ + "static/media/Elipse2.446d552a8dffb64dbab685be08a1dacf.svg";
export { ForwardRef as ReactComponent };